export class SchemaRegistrySubjectsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfig",
            "format": ""
        },
        {
            "name": "nameFilter",
            "baseName": "nameFilter",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistrySubjectsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
